import React from "react";
import Header from "../layouts/header";
import RegisteredCandidatesCountReport from "../components/registeredCandidatesCountReport";

export default function registeredCandidatesCountReportPage() {

    return (
        <div>
            <Header />
            <RegisteredCandidatesCountReport />
        </div>
    )
};